import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { User, UserRole } from '../../models/user';
import { CommonModule } from '@angular/common';
import { MenuData } from '../../models/menu-data';
import { DashboardMenuComponent } from "../dashboard-menu/dashboard-menu.component";
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-admin',
  imports: [CommonModule, DashboardMenuComponent, RouterOutlet],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent implements OnInit {

  public user!: User;

  public menuData: MenuData = {
    sections: [
      {
        sectionTitle: 'Main Menu',
        items: [
          { label: 'Dashboard', route: '/admin/dashboard', icon: 'dashboard_icon.svg' },
          { label: 'Users', route: '/admin/users', icon: 'users_icon.svg' },
          { label: 'Agents', route: '/admin/agents', icon: 'agent_icon.svg' },
          { label: 'Creators', route: '/admin/creators', icon: 'creator_icon.svg' }
        ]
      },
      {
        sectionTitle: 'Legal',
        items: [
          { label: 'Payments', route: '/admin/payments', icon: 'payment_icon.svg' },
          { label: 'Source Report', route: '/source', icon: 'payment_icon.svg' },
          { label: 'Notifications', route: '/admin/notifications', icon: 'notification_icon.svg' },
          { label: 'Documents', route: '/admin/documents', icon: 'documents_icon.svg' }
        ]
      },
      {
        sectionTitle: 'Account',
        items: [
          { label: 'Account', route: '/admin/account', icon: 'account_icon.svg' },
          { label: 'Settings', route: '/admin/settings', icon: 'settings_icon.svg' },
          { label: 'Exit', route: '', queryParams: { stay: 1 }, icon: 'logout_icon.svg' }
        ]
      }
    ]
  };

  UserRole = UserRole;

  constructor(public loginService: LoginService) {}

  ngOnInit(): void {
    this.user = this.loginService.user;
  }

}
